import axios from 'axios';
import { saveAs } from 'file-saver';
import { ProgressManager } from '../progressmanager';
import { AppSettings } from '../../utils/AppSettings';
import { AlertService } from './alertService';
import { localstorage } from './localStorageService';
import { clearAuthentication, getValidAuthToken } from './authSessionService';

const apiBasePath = AppSettings.APP_API_URL;
export const axiosInstance = axios.create({
    baseURL: apiBasePath,
    timeout: 60000,
});

axiosInstance.interceptors.request.use((value: any) => {
    ProgressManager.open();
    return value;
}, undefined);

axiosInstance.interceptors.response.use((response) => {
    ProgressManager.close();
    return response;
}, (error) => {
    ProgressManager.close();
    if (error.response?.status == 401) {
        let url = "/";
        let code = localstorage.getItem('communityCode');
        if (code) {
            url += code
        }
        if (window.location.pathname !== url) {
            window.location.href = url;
        }
        return Promise.reject(error.response.data || error);
    }
    if (error.response && error.response.data) {
        if (error.response.data.message) {
            AlertService.showErrorMsg(error.response.data.message);
        }
        return Promise.reject(error.response.data);
    }
    return Promise.reject(error);
});

function getAuthToken() {
    return getValidAuthToken();
}

export const http = {
    get: get,
    post: post,
    put: put,
    delete: deleteRequest,
    download: download,
    view: viewDocument
}

async function get(options: any) {
    let token = getAuthToken();
    let config = {};
    if (token) {
        config = {
            headers: {
                'Authorization': `${token}`
            }
        };
    }
    const response = await axiosInstance.get(options.url, config);
    return response;
}

async function post(options: any) {
    let token = getAuthToken();
    var config = {};
    if (token) {
        config = {
            headers: {
                'Authorization': `${token}`
            }
        };
    }
    const response = await axiosInstance.post(options.url, options.data, config);
    return response;
}

async function put(options: any) {
    let token = getAuthToken();
    var config = {};
    if (token) {
        config = {
            headers: {
                'Authorization': `${token}`
            }
        };
    }
    const response = await axiosInstance.put(options.url, options.data, config);
    return response;
}

async function deleteRequest(options: any) {
    let token = getAuthToken();
    var config = {};
    if (token) {
        config = {
            headers: {
                'Authorization': `${token}`
            }
        };
    }
    const response = await axiosInstance.delete(options.url, config);
    return response;
}

async function download(options: any) {
    let url = options.url;
    let method = options.method;
    let data = options.data;
    let fileName = options.fileName;
    let token = getAuthToken();
    let config: any = {
        baseURL: apiBasePath,
        url,
        method,
        data,
        responseType: 'blob',
    };
    if (token) {
        config = {
            ...config, ...{
                headers: {
                    'Authorization': `${token}`
                }
            }
        };
    }

    ProgressManager.open();
    axios.request(config)
        .then((res) => {
            let blob = res.data;
            saveAs(blob, options.fileName);
            ProgressManager.close();
        });
}


async function viewDocument(options: any) {
    let url = options.url;
    let method = options.method;
    let data = options.data;
    let fileName = options.fileName;
    let token = getAuthToken();
    let config: any = {
        baseURL: apiBasePath,
        url,
        method,
        data,
        responseType: 'blob',
    };
    if (token) {
        config = {
            ...config, ...{
                headers: {
                    'Authorization': `${token}`
                }
            }
        };
    }

    ProgressManager.open();
    axios.request(config)
        .then((res) => {
            ProgressManager.close();
            return res.data;
        })
        .then(blobToBase64)
        .then(finalResult => {
            options.callback({ base64data: finalResult, options: options });
        })
        .catch((err) => {
            ProgressManager.close();
            console.log(err);
        });
}

const blobToBase64 = (blob: any) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    return new Promise(resolve => {
        reader.onloadend = () => {
            resolve(reader.result);
        };
    });
};
